import CryptoJS from "crypto-js";
import swal from "sweetalert";
import axios from "axios";
/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const serverStatus = 'Live';
export const serverLink = serverStatus === 'Dev' ? 'http://localhost:5009/' : 'https://api.transparency.education.gov.ng/';
export const projectTitle = 'Federal Tertiary Institutions Governance Transparency Portal';
export const projectAbbr = 'FTIGTP';
export const projectShort = 'HITP';
export const projectCode = `${projectShort}-SECRET-1@-KEY`;
export const projectEmail = 'support.transparency@education.gov.ng';
export const projectPhone = '+234 809 891 1911';
export const projectAddress = 'Director, ICT Department';
export const defaultMenuType = 'menu-default';
export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'en';
export const localeOptions = [
  { id: 'en', name: 'English - LTR', direction: 'ltr' },
];

export const homeRoot = '/';
export const adminRoot = '/portal';
export const searchPath = `${adminRoot}/#`;

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = false;
export const defaultColor = 'light.greenmoss';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'red',
];

export function encryptData(string, val = false) {
  try {
    let secret_key =
        val === false
            ? `${projectCode}APISecret1@!99$%^(*^>Key` + "_ENCRYPT"
            : projectCode
    let secret_iv =
        val === false
            ? `${projectCode}APISecret1@!99$%^(*^>Key` + "_ENCRYPT_IV"
            : projectCode
    // hash
    let kee = CryptoJS.SHA256(secret_key)
    let ivv = CryptoJS.SHA256(secret_iv).toString().substr(0, 16)

    kee = CryptoJS.enc.Utf8.parse(kee.toString().substr(0, 32))
    ivv = CryptoJS.enc.Utf8.parse(ivv)

    let decrypted = CryptoJS.AES.encrypt(string, kee, { iv: ivv })

    let result = decrypted.toString()
    return btoa(result);
  } catch (e) {
    console.log(e)
  }
}
export function decryptData(string, val = false) {
  try {
    const secret_key =
        val === false
            ? `${projectCode}APISecret1@!99$%^(*^>Key` + "_ENCRYPT"
            : projectCode
    const secret_iv =
        val === false
            ? `${projectCode}APISecret1@!99$%^(*^>Key` + "_ENCRYPT_IV"
            : projectCode
    // hash
    let kee = CryptoJS.SHA256(secret_key)
    let ivv = CryptoJS.SHA256(secret_iv).toString().substr(0, 16)

    kee = CryptoJS.enc.Utf8.parse(kee.toString().substr(0, 32))
    ivv = CryptoJS.enc.Utf8.parse(ivv)

    const decrypted = CryptoJS.AES.decrypt(atob(string), kee, { iv: ivv })

    return decrypted.toString(CryptoJS.enc.Utf8)
  } catch (e) {
    console.log(e)
  }
}
export const formatDateAndTime = (date, option) => {
  if (date !== null) {
    const user_date = new Date(date);
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const monthNamesShort = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day =
        user_date.getDate() < 10
            ? "0" + user_date.getDate()
            : user_date.getDate();
    const hour =
        user_date.getHours() < 10
            ? "0" + user_date.getHours()
            : user_date.getHours();
    const min =
        user_date.getMinutes() < 10
            ? "0" + user_date.getMinutes()
            : user_date.getMinutes();
    const sec =
        user_date.getSeconds() < 10
            ? "0" + user_date.getSeconds()
            : user_date.getSeconds();

    let date_string = "";
    if (option === "date_and_time")
      date_string = `${day}-${monthNames[user_date.getMonth()]
      }-${user_date.getFullYear()} : ${hour}:${min}:${sec}`;
    else if (option === "date")
      date_string = `${day}-${monthNames[user_date.getMonth()]
      }-${user_date.getFullYear()}`;
    else if (option === "day") date_string = day;
    else if (option === "full_month")
      date_string = monthNames[user_date.getMonth()];
    else if (option === "short_month")
      date_string = monthNamesShort[user_date.getMonth()];
    else if (option === "year_only") date_string = user_date.getFullYear();
    else if (option === "month_and_year")
      date_string = `${monthNamesShort[user_date.getMonth()]} - ${user_date.getFullYear()}`;
    else if (option === "full_month_and_year")
      date_string = `${monthNames[user_date.getMonth()]} - ${user_date.getFullYear()}`;

    return date_string;
  } else {
    return "--";
  }
};

export const currencyConverter = (amount) => {
  const formatter = new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
  });
  return formatter.format(amount)
}

export const currencyConverterUSD = (amount) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  return formatter.format(amount)
}

export const numberFormat = (number) => {
  const formatter = new Intl.NumberFormat('en-NG');
  return formatter.format(number)
}

export const generate_token = (length) => {
  //edit the token allowed characters
  let a = "0123456789".split("");
  let b = [];
  for (let i = 0; i < length; i++) {
    let j = (Math.random() * (a.length - 1)).toFixed(0);
    b[i] = a[j];
  }
  return b.join("");
};

export const validatePassword = (value) => {
  let error;
  if (!value) {
    error = 'Please enter your password';
  } else if (value.length < 6) {
    error = 'Value must be longer than 5 characters';
  }
  return error;
};

export const validateEmail = (value) => {
  let error = '';
  if (!value) {
    error = 'Please enter your email address';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = 'Invalid email address';
  }
  return error;
};


export function  showConfirm(title, msg, type, cancelText = 'Cancel', confirmText = 'OK') {
  // type: error, success, warning, confirm
  return swal({
    title: title,
    text: msg,
    icon: type,
    buttons: {
      cancel: cancelText,
      confirm: {
        text: confirmText,
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    },
    dangerMode: true,
  })
}

export const sumObjectArray = (array, amount) => {
    return array.length === 0 ? 0 : array.map(item => item[amount]).reduce((prev, next) => prev + next)
  }

export const markRead = async ({user_id,user_type,username,action,module,description,token}) => {
  const sendData = {
    user_id: user_id, user_type: user_type,
    username: username, action: action,
    module: module, description: description,
  }
  await axios.post(`${serverLink}report/mark-read`, sendData, token)
      .then(() => {})
      .catch((e) => {
        console.log(e)
      })
}